import React, { useEffect, useState } from "react";
import { PencilSimple } from "@phosphor-icons/react";
import { fetchRooms } from "../../lib/api";

export default function RoomsPage() {
  const [rooms, setRooms] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchRooms()
      .then((data) => setRooms(Array.isArray(data) ? data : []))
      .catch((err) => setError(err?.message || "Errore di caricamento"));
  }, []);

  return (
    <div className="p-8 lg:p-12" data-testid="admin-rooms-page">
      <header className="mb-10">
        <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-2">
          Contenuti
        </div>
        <h1 className="font-serif text-4xl lg:text-5xl leading-tight">Camere</h1>
        <p className="text-white/50 mt-3 text-sm">
          Anteprima delle camere pubblicate sul sito. Editor in arrivo nella prossima versione.
        </p>
      </header>

      {error && (
        <div className="border border-red-500/40 bg-red-500/5 text-red-300 px-4 py-3 text-sm mb-6">
          {error}
        </div>
      )}
      {!rooms && !error && <div className="text-white/40 text-sm">Caricamento…</div>}

      {rooms && (
        <div className="grid lg:grid-cols-2 gap-6">
          {rooms.map((r) => (
            <article
              key={r.id}
              className="border border-white/10 overflow-hidden flex flex-col"
              data-testid={`admin-room-card-${r.slug_it}`}
            >
              <div className="aspect-[16/9] bg-[#0c0c0e] overflow-hidden">
                {r.cover && (
                  <img src={r.cover} alt={r.name_it} className="w-full h-full object-cover" />
                )}
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-start justify-between gap-4 mb-3">
                  <div>
                    <h2 className="font-serif text-2xl leading-tight">{r.name_it}</h2>
                    <div className="text-xs text-white/40 mt-1">{r.name_en}</div>
                  </div>
                  <div className="text-right text-xs text-white/50 shrink-0">
                    <div>da</div>
                    <div className="font-serif text-xl text-[#C5A059]">
                      {r.price_from}€<span className="text-xs"> / notte</span>
                    </div>
                  </div>
                </div>

                <p className="text-sm text-white/60 mb-2 line-clamp-2">{r.short_it}</p>

                <div className="mt-auto pt-4 border-t border-white/5 flex items-center justify-between text-xs text-white/40">
                  <div className="flex gap-3">
                    <span>{r.size_sqm} m²</span>
                    <span>·</span>
                    <span>{r.occupancy} ospiti</span>
                    <span>·</span>
                    <span className="truncate">{r.bed_type_it}</span>
                  </div>
                  <button
                    disabled
                    title="Prossimamente"
                    className="inline-flex items-center gap-1 text-white/30 cursor-not-allowed"
                  >
                    <PencilSimple size={12} weight="light" />
                    Modifica
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
